import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { ApiService } from '../../api.service';
import { Store } from '@ngrx/store';
import { GlobalService } from '../../global.service';
import { Router } from "@angular/router";
import { MainCampaignActions } from "../../main-campaign/main-campaign.actions";

@Component({
	selector: 'app-broadbrand',
	templateUrl: './broadbrand.component.html',
	styleUrls: ['./broadbrand.component.scss']
})
export class BroadbrandComponent implements OnInit {

	isBroadBrand: boolean = false;
	// data_broadbrand : any;
	status:boolean = false;
	selected: any = false;
	submit_broadrand: Array<any> = [];
	// @Input() data_broadband: any;
	data_broadband: any;

	@Output() valueChange = new EventEmitter();

	constructor(private apiService: ApiService, private store: Store<any>,
		private globalService: GlobalService, 
		private mainCampaignActions: MainCampaignActions, 
		private router: Router
		) {
			
	}


	ngOnInit() {
		this.isBroadBrand = true;
		this.getBroadband();
	}

	/** call broadbrand */
	getBroadband(){
		if(!this.data_broadband){
			$(".loading_check").css({
				'opacity': '1', 'z-index': '999'
			})
		}

		/**data request to get Broadbrand */
		let dataRequestBroadbrand = {
			campaign_Id: parseInt(this.globalService.getSession("id_campaign")),
			plan_Id: ''
		}
		this.apiService.getBroadbrand(dataRequestBroadbrand).subscribe(res => {
			if (res.success) {
				$(".loading_check").css({
					'opacity': '0', 'z-index': '-1'
				})

				this.data_broadband = res.data.broad_campaign.original.data.collection;				
				this.contentBroad(this.data_broadband);
				this.globalService.setSession('broad_campaign', this.data_broadband);

				this.valueChange.emit(this.data_broadband);
			}
		})
	}
		

	

	contentBroad(data) {
		data.sort(function (a, b) {
			return a.price - b.price;
		});

		data.forEach(element => {
			return element.selected = false
		});

		

		setTimeout(() => {
			if (data.length < 4) {
				$('.broadbrand_pc').addClass('justify-content-md-center');
			} else {
				$('.broadbrand_pc').removeClass('justify-content-md-center');
				var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
				if (isSafari) {
					// console.log("You are using Safari on iOS!");
					$('.broadbrand_pc').css("display","block")
				} else {
					// console.log("other.");
				}
			}


			//layout mobile 
			(<any>$)(".broadbrand-slider_mobile").on("init , setPosition", function () {
				if ($(window).outerWidth() <= 768) {
					$(".broadbrand_pc .slick-list").css("padding", "0px 15px");
					$(".broadbrand_pc").hide();
					$(".broadbrand-slider_mobile").show();
					
					
				} else {
					$(".broadbrand-slider_mobile").hide();
					$(".broadbrand_pc").show();
				}
			});
			(<any>$)(".broadbrand-slider_mobile").not('.slick-initialized').slick({
				slidesToShow: 1,
				dots: true,
				infinite: false,
				centerMode: true,
				arrows: false,
				autoplay: true
			});
			
			$(window).on("load", function(){
				setTimeout(() => {
					(<any>$)(".broadbrand-slider_mobile").not('.slick-initialized').slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						infinite: true,
						centerMode: true,
						arrows: false,
						autoplay:true,
						autoplaySpeed: 1500,
					});
				}, 1000);
				
			})
			

		}, 200);
	}

	


	// go to step 3
	select_broadBrand(item) {
		// no choose plan -> planId = ''
		item.selected = true;
		let newValueSession = {
			planId: '',
			broad_campaign : item
		};
		this.globalService.setSession("mainApplication", newValueSession);
		this.globalService.setSession("digi_type", 'broad_type');

		// console.log(this.globalService.getSession("mainApplication"))
		this.store.dispatch(this.mainCampaignActions.goToStep3(true));
		this.router.navigateByUrl("/main-campaign");
	}

	// submit_ViewPlans() {
	// 	this.router.navigateByUrl("/main-campaign");
	// 	this.globalService.setSession("broadband", this.data_broadband);
	// }

}
